/// <amd-module name="SuiteCommerce.SizeChart.Chart.Router"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.SizeChart.Chart.Router", ["require", "exports", "Backbone", "SuiteCommerce.SizeChart.NotFoundPage.View", "SuiteCommerce.SizeChart.Chart.Page.Model", "SuiteCommerce.SizeChart.Chart.Page.View", "SuiteCommerce.SizeChart.Instrumentation"], function (require, exports, Backbone_1, NotFoundPage_View_1, Chart_Page_Model_1, Chart_Page_View_1, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ChartRouter = void 0;
    var ChartRouter = /** @class */ (function (_super) {
        __extends(ChartRouter, _super);
        function ChartRouter(options) {
            var _this = _super.call(this, options) || this;
            _this.application = options.application;
            _this.environment = options.application.getComponent('Environment');
            return _this;
        }
        Object.defineProperty(ChartRouter.prototype, "routes", {
            get: function () {
                return {
                    'size-charts(/)(/:sizeChartSearchKey)(/)': 'openSizeChartAction',
                };
            },
            enumerable: false,
            configurable: true
        });
        ChartRouter.prototype.openSizeChartAction = function (sizeChartSearchKey) {
            this.showSizeChartView(sizeChartSearchKey);
        };
        ChartRouter.prototype.showSizeChartView = function (sizeChartSearchKey, isRenderedInModal) {
            var _this = this;
            if (isRenderedInModal === void 0) { isRenderedInModal = false; }
            this.isSearchingSizeCharts = true;
            var chartPageModel = new Chart_Page_Model_1.ChartPageModel({
                isRenderedInModal: isRenderedInModal,
                sizeChartSearchKey: sizeChartSearchKey,
            });
            var fetchPromise;
            var sizeChartLoadingTimeLog = Instrumentation_1.default.getLog('sizeChartLoadingTimeLog');
            sizeChartLoadingTimeLog.startTimer();
            if (sizeChartSearchKey) {
                fetchPromise = chartPageModel.charts.fetch({
                    data: { sizeChartSearchKey: sizeChartSearchKey },
                });
            }
            else {
                fetchPromise = chartPageModel.charts.fetch();
            }
            fetchPromise.done(function () {
                sizeChartLoadingTimeLog.endTimer();
                _this.isSearchingSizeCharts = false;
                if (chartPageModel.charts.size() > 0) {
                    var chartPageView = new Chart_Page_View_1.ChartPageView({
                        model: chartPageModel,
                        application: _this.application,
                    });
                    if (isRenderedInModal) {
                        chartPageView.showInModal();
                    }
                    else {
                        chartPageView.showContent();
                        _this.logSizeChartsPageVisit(chartPageModel.charts.size() === 1
                            ? chartPageModel.charts.at(0)
                            : null);
                    }
                }
                else {
                    var notFoundView = new NotFoundPage_View_1.NotFoundView({
                        application: _this.application
                    });
                    notFoundView.showContent();
                }
                sizeChartLoadingTimeLog.setParameters({
                    activity: 'Time it takes to load the size chart data',
                    instanceCount: chartPageModel.charts.size(),
                    totalTime: sizeChartLoadingTimeLog.getElapsedTimeForTimer(),
                });
                sizeChartLoadingTimeLog.submit();
            });
        };
        ChartRouter.prototype.logSizeChartsPageVisit = function (chart) {
            if (chart === void 0) { chart = null; }
            var visitedSizeChartPageLog = Instrumentation_1.default.getLog('visitedSizeChartPageLog');
            visitedSizeChartPageLog.setParameters({
                activity: 'Visited Size Chart landing page',
                message: "Size chart: " + (chart ? "Id:" + chart.internalId + " - Name: " + chart.name : 'All'),
            });
            visitedSizeChartPageLog.submit();
        };
        return ChartRouter;
    }(Backbone_1.Router));
    exports.ChartRouter = ChartRouter;
});
